<template>
  <LoggerInfoDetails logger_type="level"></LoggerInfoDetails>
</template>

<script>
import LoggerInfoDetails from '../details'

export default {
  name: 'level_details',
  components: { LoggerInfoDetails }
}
</script>
